import { SDKEvent } from '../types/SDKEvent';

const dispatch = (event: SDKEvent): void => {
    window.dispatchEvent(new CustomEvent(event.type, { detail: event }));
};

export default dispatch;
